// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__lriky","copy":"Footer_copy__TSbmU","ok":"Footer_ok__ifcO4","nav":"Footer_nav__9-WID","link":"Footer_link__cSGdr"};